export const MOVE_MEDIA_PAGE = 'MOVE_MEDIA_PAGE';
